module.exports = __webpack_public_path__ + "static/img/Logotipo_Positivo_Vertical-recibo.946b755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logotipo_Positivo_Vertical-recibo.png
// module id = 2Vnh
// module chunks = 2